module.exports = __webpack_public_path__ + "media/assets/arrow-right-bottom-85637916170f101679e3981e56091feb3be3cd45908acfa7491ac869688538ac.png";